import Vue from 'vue'
import Vuex from 'vuex'
import auth from '@/store/modules/auth.js'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
  },
  state: {
    accessToken: null,
    isLoading: false,
  },
  actions: {
    updateAccessToken({ commit }, obj) {
      commit('setAccessToken', obj)
    },
  },
  mutations: {
    setAccessToken(state, accessToken) {
      state.accessToken = accessToken
    },
    loading(state, payload) {
      state.isLoading = payload
    },
  },
})
